import React from 'react';

/*
 * Media icons from Google Material Symbols (Apache 2.0), the same set as the homepage hero video
 * in browse-cmspages. Local because the design-system icon registry has no media icons. All
 * decorative: the owning button carries the accessible name.
 */

interface IconProps {
  size?: number;
}

const svgProps = (size: number) =>
  ({
    'aria-hidden': true,
    fill: 'currentColor',
    height: size,
    viewBox: '0 -960 960 960',
    width: size,
  } as const);

export const PlayIcon = ({ size = 24 }: IconProps) => (
  <svg {...svgProps(size)}>
    <path d="M320-200v-560l440 280-440 280Z" />
  </svg>
);

export const PauseIcon = ({ size = 24 }: IconProps) => (
  <svg {...svgProps(size)}>
    <path d="M560-200v-560h160v560H560Zm-320 0v-560h160v560H240Z" />
  </svg>
);

export const FullscreenIcon = ({ size = 24 }: IconProps) => (
  <svg {...svgProps(size)}>
    <path d="M120-120v-200h80v120h120v80H120Zm520 0v-80h120v-120h80v200H640ZM120-640v-200h200v80H200v120h-80Zm640 0v-120H640v-80h200v200h-80Z" />
  </svg>
);
